import axios from "axios";

const baseUrl = process.env.REACT_APP_BE_URL;
const domainUrl = window.location.hostname;
export function getTimeZone() {
    var offset = new Date().getTimezoneOffset(),
        o = Math.abs(offset);
    return (
        (offset < 0 ? "+" : "-") +
        ("00" + Math.floor(o / 60)).slice(-2) +
        ":" +
        ("00" + (o % 60)).slice(-2)
    );
}
const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: {
        timezone: getTimeZone(),
        domain:
            domainUrl === "localhost" ||
            domainUrl === "classified-ads-c4c4a.web.app"
                ? "dev.oxiwear.fitness"
                : domainUrl,
    },
});

export default axiosInstance;
